import React from 'react';
import ReactDOM from 'react-dom';



import './real/styles/allstyles.css' ;



import IndexApp from './real/components/IndexApp';



ReactDOM.render(
  <React.StrictMode>
    
    <IndexApp />
    
  </React.StrictMode>,
  document.getElementById('root')
);


